const state = {
  mychart: [],
  isFullScreen: false,
  layout: [],
  widthRatio:[],
  heightRatio:[],
  boxWidthHeight:[],
  yearList:[],
  listCount:8,
  preWarnInfo:false,
  isShowModalLinkPanel: false,
  isShowModalPreWarning:false,
  isShowModalPreWarningDetail:false,
  preWarningDetailContent:{},
  isShowModalOneTouch:false,
  isShowModalPreWarn:false,
  isShowModalWarn:false,
  provinceObj:{},
  radarInfo:{},
  dashName:'',
  isLinkModal:false,
  dashType:'',
}

const mutations = {
  SET_MYCHART: (state, chart) => {
    state.mychart.push(chart)
  },
  RESET_MYCHART: (state, chart) => {
    state.mychart = chart
  },
  SET_ISFULLSCREEN: (state, isFullScreen) => {
    state.isFullScreen = isFullScreen
  },
  SET_TWOGROUNPONEDATA: (state, data) => {
    state.twoGrounpOneData = data
  },
  SET_LAYOUT: (state, layout) => {
    state.layout = layout.layout
    state.widthRatio=layout.widthRatio
    state.heightRatio=layout.heightRatio
  },
  SET_BOXWIDTHHEIGHT:(state,boxWidthHeight)=>{
    state.boxWidthHeight=boxWidthHeight
  },
  SET_YEARLIST:(state,yearList)=>{
    state.yearList=yearList
  },
  SET_PREWARNINFO:(state,preWarnInfo)=>{
    state.preWarnInfo=preWarnInfo
  },
  SET_ISSHOWMODALPREWARNING:(state,isShowModalPreWarning)=>{
    state.isShowModalPreWarning=isShowModalPreWarning
  },
  SET_ISSHOWMODALLINKPANEL:(state, isShowModalLinkPanel) => {
    state.isShowModalLinkPanel=isShowModalLinkPanel
  },
  SET_ISSHOWMODALPREWARNINGDETAIL:(state,isShowModalPreWarningDetail)=>{
    state.isShowModalPreWarningDetail=isShowModalPreWarningDetail
  },
  SET_ISSHOWMODALPREWARNINGDETAILCONTENT:(state,info)=>{
    state.preWarningDetailContent=info
  },
  SET_ISSHOWMODALONETOUCH: (state, isShowModalOneTouch) => {
    state.isShowModalOneTouch=isShowModalOneTouch
  },
  SET_ISSHOWMODALPREWARN: (state, isShowModalPreWarn) => {
    state.isShowModalPreWarn=isShowModalPreWarn
  },
  SET_ISSHOWMODALWARN: (state, isShowModalWarn) => {
    state.isShowModalWarn=isShowModalWarn
  },
  SET_PROVINCEOBJ: (state, provinceObj) => {
      state.provinceObj=provinceObj
    },
  SET_RADARINFO: (state, radarInfo) => {
      state.radarInfo=radarInfo
    },
  SET_DASHINFO: (state, dash_info) => {
    state.dashName=dash_info.dash_name
    state.isLinkModal=dash_info.is_link_modal
  },
  SET_ISLINKMODAL: (state, is_link_modal) => {
    state.isLinkModal=is_link_modal
  },
  SET_DASHTYPE: (state, dashType) => {
    state.dashType=dashType
  },
}

const actions = {
  //
  setMyChart({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_MYCHART', Info)
      resolve()
    })
  },
  resetMyChart({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('RESET_MYCHART', Info)
      resolve()
    })
  },
  setIsFullScreen({ commit }, isFullScreen) {
    return new Promise((resolve, reject) => {
      commit('SET_ISFULLSCREEN', isFullScreen)
      resolve()
    })
  },
  setLayout({ commit }, layout) {
    return new Promise((resolve, reject) => {
      commit('SET_LAYOUT', layout)
      resolve()
    })
  },
  setBoxWidthHeight({ commit }, boxWidthHeight) {
    return new Promise((resolve, reject) => {
      commit('SET_BOXWIDTHHEIGHT', boxWidthHeight)
      resolve()
    })
  },
  setYearList({ commit }, yearList) {
    return new Promise((resolve, reject) => {
      commit('SET_YEARLIST', yearList)
      resolve()
    })
  },
  setPrewarnInfo({ commit }, preWarnInfo) {
    return new Promise((resolve, reject) => {
      commit('SET_PREWARNINFO', preWarnInfo)
      resolve()
    })
  },
  setIsShowModalPreWarning({ commit }, info) {
    return new Promise((resolve, reject) => {
      commit('SET_ISSHOWMODALPREWARNING', info)
      resolve()
    })
  },
  setIsShowModalPreWarningDetail({ commit }, info) {
    return new Promise((resolve, reject) => {
      commit('SET_ISSHOWMODALPREWARNINGDETAIL', info)
      resolve()
    })
  },
  setIsShowModalLinkPanel({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_ISSHOWMODALLINKPANEL', Info)
      resolve()
    })
  },
  setIsShowModalPreWarningDetailContent({ commit }, info) {
    return new Promise((resolve, reject) => {
      commit('SET_ISSHOWMODALPREWARNINGDETAILCONTENT', info)
      resolve()
    })
  },
  setIsShowModalOneTouch({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_ISSHOWMODALONETOUCH', Info)
      resolve()
    })
  },
  setIsShowModalPreWarn({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_ISSHOWMODALPREWARN', Info)
      resolve()
    })
  },
  setIsShowModalWarn({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_ISSHOWMODALWARN', Info)
      resolve()
    })
  },
  setProvinceObj({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_PROVINCEOBJ', Info)
      resolve()
    })
  },
  setRadarInfo({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_RADARINFO', Info)
      resolve()
    })
  },
  setDashInfo({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_DASHINFO', Info)
      resolve()
    })
  },
  setIsLinkModal({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_ISLINKMODAL', Info)
      resolve()
    })
  },
  setDashType({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_DASHTYPE', Info)
      resolve()
    })
  },
  setLoading({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_LOADING', Info)
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
